/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import { SupportedLanguages } from '../utils/constants';

const isProduction = process.env.NODE_ENV === 'production';
const millisecondsInADay = 24 * 60 * 60 * 1000;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const { translationsVersion } = (window as any).config;

// development output directories are defined in bin/mount-translations.js

const translationsPath = isProduction
  ? `${process.env.REACT_APP_TRANSLATIONS_URL}/${translationsVersion}/{{lng}}/{{ns}}.json`
  : `${process.env.PUBLIC_URL}/translations/participant-experience/{{lng}}/{{ns}}.json`;

const legalTranslationsPath = isProduction
  ? `${process.env.REACT_APP_LEGAL_TRANSLATIONS_URL}/{{lng}}/{{ns}}.json`
  : `${process.env.PUBLIC_URL}/translations/legal-texts/{{lng}}/{{ns}}.json`;

const i18nConfig = {
  translationsPath,
  legalTranslationsPath,
  debug: !isProduction,
  cache: {
    prefix: 'pe_i18n_',
    versions: Object.values(SupportedLanguages).reduce(
      (languages, lang) => ({ [lang]: translationsVersion, ...languages }), {}
    ),
    expirationTime: isProduction ? millisecondsInADay : 0,
  },
};

export default i18nConfig;
